// import facebook from "../../assets/JoinNow/facebook.svg";
import { toastrSuccess, toastrError } from "./../../lib/toastr";
import LoadingOverlay from "react-loading-overlay-ts";
import { loginUser } from "../LoginForm/LoginForm.api";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { AxiosError } from "axios";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { intialState } from "./JoinNowForm.interface";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { getData, getIpAddressByIPify } from "./getdata";
// import { LoginSocialFacebook } from "reactjs-social-login";
import { useAuth } from "context/auth-context";
import { Modal } from "antd";
import { registerUserWithGoogle, saveUserDetail, verifyUser } from "./JoinNowForm.api";
import { useAltcha } from "components/core/Altcha/AltchaWidget";
// import { Successpopup } from "./Successpopup";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { FiMail } from "react-icons/fi";

const GOOGLE_PREFERENCES_SHOWN_COOKIE = "google_email_preferences_shown";
const GOOGLE_EMAIL_PREFERENCE_COOKIE = "google_email_preferences";

const isUnitedStates = (country?: string) => {
  const normalizedCountry = country?.trim().toLowerCase();

  return (
    normalizedCountry === "united states of america" ||
    normalizedCountry === "united states" ||
    normalizedCountry === "us"
  );
};

/**
 * Google signup.
 *
 * `marketingConsent` is owned by the parent (JoinNowNew) so ONE checkbox governs
 * both signup paths. If the user clicks Google without ever having seen the
 * checkbox -- it renders lower down the form -- the value is still `false` and
 * DENIED is recorded. That is the correct outcome: consent that was never shown
 * was never given, and absent must never resolve to GRANTED.
 */
export const JoinNowWithGoogle = ({ marketingConsent = false }: { marketingConsent?: boolean }) => {
  const [showEmailPreferences, setShowEmailPreferences] = useState(false);
  const [hasShownEmailPreferences, setHasShownEmailPreferences] = useState(
    () => Cookies.get(GOOGLE_PREFERENCES_SHOWN_COOKIE) === "true"
  );
  const [isSubscribed, setIsSubscribed] = useState(
    () => Cookies.get(GOOGLE_EMAIL_PREFERENCE_COOKIE) === "true"
  );
  const [Email, setEmail]: any = useState("");
  const [setVerficationName]: any = useState("");
  const [formValue, setFormValue] = useState(intialState);
  const [firstname, setFirstname] = useState("");
  const [lastName, setlastName] = useState("");
  const [sucessResponce, setSucessResponce] = useState();
  const { setAuth } = useAuth();
  const { info } = Modal;
  const [password, setPassword] = useState("");
  const { widget: altchaWidget, solve: solveAltcha } = useAltcha();
  const navigate = useNavigate();
  const [ipAddress, setIpAddressName] = useState();
  const location = useLocation();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const showEmailPreferencesOnce = () => {
    if (hasShownEmailPreferences) return;

    setIsSubscribed(isUnitedStates(formValue.country));
    setShowEmailPreferences(true);
  };
  const saveGoogleEmailPreference = () => {
    const cookieOptions = {
      expires: 365,
      sameSite: "lax" as const,
      secure: window.location.protocol === "https:",
    };

    Cookies.set(GOOGLE_PREFERENCES_SHOWN_COOKIE, "true", cookieOptions);
    Cookies.set(GOOGLE_EMAIL_PREFERENCE_COOKIE, String(isSubscribed), cookieOptions);
    setHasShownEmailPreferences(true);
  };
  const handleSuccess = (credentialResponse: any) => {
    if (credentialResponse) {
      setSucessResponce(credentialResponse);
      let userEmail: any;
      if (credentialResponse && credentialResponse?.credential) {
        userEmail = jwtDecode(credentialResponse?.credential);
        if (userEmail) {
          setlastName(userEmail?.family_name);
          setEmail(userEmail?.email);
          setFirstname(userEmail?.given_name);
        }
        userEmail = userEmail?.email;

        userEmail = userEmail?.family_name;
      } else if (credentialResponse && credentialResponse?.email) {
        userEmail = credentialResponse?.email;
      }

      if (userEmail && credentialResponse?.credential) {
        let verificationGoogle: any;
        verificationGoogle = jwtDecode(credentialResponse?.credential);
        verificationGoogle = verificationGoogle?.email_verified;
        verificationGoogle ? setVerficationName("Google") : "";
      }
    } else {
      toastrError(t("joinow.component.credentialResponse"));
    }
  };

  const virtualWalletConfirmation: any = (location: any) => {
    info({
      title: "Alert",
      icon: <ExclamationCircleFilled />,
      content: "get errr with that",
      onOk() {
        navigate(location.state || "/dashboard", { state: null });
      },
    });
  };

  const initialState = {
    email: "",
    password: "",
    errors: {
      email: "",
      password: "",
    },
  };

  type formValue = typeof initialState;
  type LoginPayload = Omit<formValue, "errors">;
  const handleError = () => {
    toastrError(t("form.join.password"));
  };

  const authMutation = useMutation(
    (payload: LoginPayload) => {
      return loginUser(payload.email, payload.password, 'GOOGLE');
    },
    {
      onSuccess: (response: any) => {
        // Check if MFA is required
        if (response?.requireMfa) {
          navigate("/mfa-verify", {
            state: {
              signInData: {
                data: {
                  email: response.email,
                },
              },
            },
          });
          return;
        }
        localStorage.setItem("access_token", response.token);
        if (response.isFlagVirtualWallet) {
          toastrSuccess(t("joinow.component.sucesssfuly"));
          virtualWalletConfirmation(location);
          setAuth(response.result.result);
          navigate("/dashboard");
        } else {
          toastrSuccess(t("joinow.component.sucesssfuly"));
          setAuth(response.result.result);
          navigate(location.state || "/dashboard", { state: null });
        }
      },
      onError: (err: AxiosError) => {
        const repsonse = err.response as any;
        if (repsonse.data && repsonse.data.message) {
          toastrError(repsonse.data.message);
        } else {
          toastrError(t("form.join.password"));
        }
      },
    }
  );

  // varify user
  const verifyUserMutation = useMutation((cred: { email: string }) => verifyUser(cred), {});
  // save user details
  const saveuserdetails = useMutation(() =>
    saveUserDetail(formValue.currentUrl, formValue.country, ipAddress)
  );

  // register user
  const resisteruser = useMutation(
    async () =>
      registerUserWithGoogle({
        altcha: await solveAltcha(),
        marketingConsent,
        isSubscribed: isSubscribed ? 1 : 0,
        credential: (sucessResponce as any)?.credential,
        password: password,
        firstName: firstname,
        lastName: lastName,
        email: Email,
        dateOfBirth: "",
        gender: "",
        active: formValue.active,
        language: formValue.language,
        timeZone: formValue.timeZone,
        currentUrl: formValue.currentUrl,
        sid: "",
        country: formValue.country,
        state: formValue.state,
        geo: "",
        clickid: "",
        referalId: formValue.referalId,
        socialID: "",
        ipAddress: ipAddress,
        sessionId: formValue.sessionId,
        uid: formValue.uid,
        isGuest: formValue.sessionId && formValue.uid ? 1 : 0,
      }),
    {
      onSuccess: async (data) => {
        if (data.result.success) {
          if (data?.result?.result?.newUser) {
            localStorage.setItem("joinQualPopup", "true");
          }
          toastrSuccess(t("joinow.component.sucesssfuly"));
          localStorage.setItem("access_token", data.token);
          setAuth(data.result.result);
          navigate(location.state || "/dashboard", { state: null });
        } else {
          toastrError(t("joinow.component.err"));
        }
      },
      onError: (err: AxiosError) => {
        const response = err.response as any;
        toastrError(response?.data?.message || err.message || t("joinow.component.please"));
      },
    }
  );

  useEffect(() => {
    const initialize = async () => {
      await getData(setIpAddressName, setPassword, setFormValue, formValue, password, Email, firstname, searchParams);
      const ipAddress = await getIpAddressByIPify();
      setIpAddressName(ipAddress);
    };

    initialize();
  }, []);

  // loginwith google
  useEffect(() => {
    if (sucessResponce) {
      handleSuccess(sucessResponce);

      verifyUserMutation.mutate({ email: Email });
      resisteruser.mutate();
      saveuserdetails.mutate();
    }
  }, [sucessResponce]);

  // const handlePopupClose = () => {
  //   setIsSuccessPopupVisible(false);
  //   // setShowSuccessPopup(false);
  // };

  return (
    <>
      {/* Mounted so solve() has an element to drive; hidden because the Google
          button is its own affordance and the work is sub-second. */}
      <span className="hidden">{altchaWidget}</span>
      <LoadingOverlay
        styles={{
          overlay: (base) => ({
            ...base,
            position: "fixed",
          }),
        }}
        active={authMutation.isLoading}
        spinner
        text={t("claim.card.Loading")}
      ></LoadingOverlay>
      <div className="relative w-full">
        <button
          type="button"
          onClick={showEmailPreferencesOnce}
          className="zs-btn zs-btn-secondary zs-btn-lg zs-btn-block gap-3"
        >
          <img
            src="https://www.svgrepo.com/show/355037/google.svg"
            alt="Google"
            className="w-5 h-5"
          />
          Continue with Google
        </button>
        {hasShownEmailPreferences && !showEmailPreferences && (
          <div className="absolute inset-0 z-10 overflow-hidden opacity-[0.01] [&>div]:!h-full [&>div]:!w-full [&_iframe]:!h-full [&_iframe]:!w-full">
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={handleError}
              size="large"
              text="continue_with"
              width="100%"
            />
          </div>
        )}
      </div>

      <Modal
        open={showEmailPreferences}
        onCancel={() => setShowEmailPreferences(false)}
        footer={null}
        centered
        width={560}
        destroyOnClose
      >
        <div className="px-1 py-2 sm:px-2">
          <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-lg bg-primary-soft text-primary-text">
            <FiMail className="h-5 w-5" aria-hidden="true" />
          </span>
          <h2 className="font-display text-xl font-bold tracking-tight text-ink">Email preferences</h2>
          <p className="mt-1.5 text-sm text-ink-3">
            This is optional. You can continue without selecting it.
          </p>

          <label className="mt-6 flex cursor-pointer items-start gap-3 rounded-lg border border-line bg-surface-2 p-4 text-sm leading-6 text-ink-2 transition-colors hover:border-line-strong">
            <input
              type="checkbox"
              checked={isSubscribed}
              onChange={(event) => setIsSubscribed(event.target.checked)}
              className="mt-1 h-[18px] w-[18px] shrink-0 cursor-pointer accent-primary"
            />
            <span className="text-ink-2">
              Yes, I&apos;d like to receive survey invitations, reward updates, and occasional
              promotional emails from Zamplia Surveys. I can unsubscribe at any time.
            </span>
          </label>

          <p className="mt-3 text-xs text-ink-4 sm:text-sm">
            You can update your email preferences or unsubscribe at any time.
          </p>

          <div className="mt-7 flex flex-col-reverse justify-end gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => setShowEmailPreferences(false)}
              className="zs-btn zs-btn-secondary"
            >
              Cancel
            </button>
            <div className="relative min-h-[40px] min-w-[220px] overflow-hidden rounded border border-line-strong shadow-xs">
              <div className="pointer-events-none absolute inset-0 flex items-center justify-center gap-2 bg-surface text-sm font-medium text-ink">
                <img
                  src="https://www.svgrepo.com/show/355037/google.svg"
                  alt=""
                  className="h-4 w-4"
                />
                Continue with Google
              </div>
              <div className="absolute inset-0 z-10 overflow-hidden opacity-[0.01] [&>div]:!h-full [&>div]:!w-full [&_iframe]:!h-full [&_iframe]:!w-full">
                <GoogleLogin
                  onSuccess={(credential) => {
                    saveGoogleEmailPreference();
                    setShowEmailPreferences(false);
                    handleSuccess(credential);
                  }}
                  onError={() => {
                    setShowEmailPreferences(false);
                    handleError();
                  }}
                  size="large"
                  text="continue_with"
                  width="220"
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
